import { IconName, Button } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithAccountId } from '@mews-commander/types';
import { isAccountIdCompany } from '@mews-commander/legacy-entities/src/selectors/bills';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { openAccountBillingModal } from '../ducks/navigation';

interface AccountBillingButtonProps extends WithAccountId {
    billCount: number;
}

export const AccountBillingButton = ({ accountId, billCount }: AccountBillingButtonProps) => {
    const dispatch = useCommanderThunkDispatch();
    const isCompanyBilling = useCommanderSelector((state) => isAccountIdCompany(state, { accountId }));

    const openCustomerBills = () => dispatch(openAccountBillingModal({ accountId }));

    return (
        <Button variant="ghost" icon={IconName.Profile} onClick={openCustomerBills} counter={billCount} type="submit">
            <LocalizedText textKey={isCompanyBilling ? TextKey.AllCompanysBills : TextKey.AllGuestsBills} />
        </Button>
    );
};
